<template lang="html">
  <el-row class="p-bind container">
    <el-row class="login-wrap">
      <el-row class="bind-con">
        <el-row class="bind-header">
          <el-row class="bind-logo">
            <template v-if="logo_url">
              <img :src="logo_url" alt="" width="60px" class="logo">
            </template>
            <template v-else>
              <img src="../assets/logo-yimian.png" alt="YIMIAN" width="60px" class="logo">
            </template>
          </el-row>
          <h2>{{ $t('bind.page.title')}}</h2>
          <p
            v-if="current_bind!='bind_user'"
            class="bind-text"
          >
            {{ $t('bind.page.description')}}
          </p>
        </el-row>

        <el-row class="bind-content">
          <el-row v-if="current_bind=='bind_user'">
            <span class="bind-success">
              <i class="el-icon-check"></i>
            </span>
            <p
              class="bind-text"
              v-html="$t('bind.bind_html', this.bindParams)"
            />
          </el-row>

          <el-row v-if="current_bind=='old_user'">
            <el-form
              :model="confirmForm"
              ref="confirmForm"
              class="bind-form"
            >
              <el-form-item
                prop="app_name"
                :label="$t('common.application')"
              >
                <el-input
                  v-model="confirmForm.app_name"
                  disabled
                ></el-input>
              </el-form-item>
              <el-form-item
                prop="email"
                :label="$t('common.email')"
              >
                <el-input
                  v-model="confirmForm.email"
                  disabled
                ></el-input>
              </el-form-item>
              <el-form-item class="bind-btns">
                <!-- <el-col :span="11">
                  <el-button>
                    {{ $t('common.cancel') }}
                  </el-button>
                </el-col> -->
                <el-col>
                  <el-button
                    @click="confirmBind"
                    type="primary"
                  >
                    {{ $t('common.bind') }}
                  </el-button>
                </el-col>
              </el-form-item>
            </el-form>
          </el-row>

          <el-row v-if="current_bind=='new_user'">
            <el-form
              :model="confirmForm"
              ref="confirmForm"
              :rules="rules"
              class="bind-form"
            >
              <el-form-item
                prop="app_name"
                :label="$t('common.application')"
              >
                <el-input
                  v-model="confirmForm.app_name"
                  disabled
                ></el-input>
              </el-form-item>
              <el-form-item
                prop="email"
                :label="$t('common.email')"
              >
                <el-input
                  v-model="confirmForm.email"
                  disabled
                ></el-input>
              </el-form-item>
              <el-form-item
                prop="username"
                :label="$t('common.username')"
              >
                <el-input
                  v-model.trim="confirmForm.username"
                  :placeholder="$t('common.usernamePlaceholder')"
                ></el-input>
              </el-form-item>
              <el-form-item
                prop="password"
                :label="$t('common.password')"
              >
                <el-input
                  type="password"
                  :placeholder="$t('common.passwordPlaceholder')"
                  :readonly="readOnlyFlag"
                  @focus="readOnlyFlag = false;"
                  v-model="confirmForm.password"
                ></el-input>
              </el-form-item>
              <el-form-item
                prop="confirmPassword"
                :label="$t('common.confirmPassword')"
              >
                <el-input
                  type="password"
                  :placeholder="$t('common.confirmPasswordPlaceholder')"
                  v-model="confirmForm.confirmPassword"
                  :readonly="readOnlyFlag"
                  @focus="readOnlyFlag = false;"
                  @keyup.enter.native="confirmBind"
                ></el-input>
              </el-form-item>
              <el-form-item class="bind-btns">
                <!-- <el-col :span="11">
                  <el-button>
                    {{ $t('common.cancel') }}
                  </el-button>
                </el-col> -->
                <el-col>
                  <el-button
                    @click="confirmBind"
                    type="primary"
                  >
                    {{ $t('common.bind') }}
                  </el-button>
                </el-col>
              </el-form-item>
            </el-form>
          </el-row>
        </el-row>
      </el-row>
    </el-row>
  </el-row>
</template>

<script>
  export default {
    data() {
      const usernameValidator = (rule, value, cb) => {
        if (!value || !String(value).trim()) {
          cb(new Error(this.$t('rules.username')));
        } else {
          cb();
        }
      };
      const pwValidator = (rule, value, cb) => {
        const ptn = this.$consts.PASSWORD_REGEXP;
        if (value === '') {
          cb(new Error(this.$t('common.passwordPlaceholder')));
        } else if (!ptn.test(value)) {
          cb(new Error(this.$t('rules.password_format')));
        } else {
          cb();
        }
      };
      const pwConfirmValidator = (rule, value, cb) => {
        if (!value) {
          cb(new Error(this.$t('common.confirmPasswordPlaceholder')));
        } else if (value !== this.confirmForm.password) {
          cb(new Error(this.$t('rules.password_repeat')));
        } else {
          cb();
        }
      };
      return {
        app_key: 'qZkZT5WZSdirdcL88wyRx5pN8tsyaqAi',
        logo_url: null,
        bindParams: {
          email: '',
          app_name: '',
          app_url: '',
        },
        confirmForm: {
          email: null,
          username: null,
          password: null,
          confirmPassword: null,
        },
        rules: {
          username: [
            { required: true, validator: usernameValidator, trigger: 'change' },
          ],
          password: [
            { required: true, validator: pwValidator, trigger: 'change' },
          ],
          confirmPassword: [
            { required: true, validator: pwConfirmValidator, trigger: 'change' },
          ],
        },
        current_bind: '',
        readOnlyFlag: true,
        password_error: false,
        forbid: false,
      };
    },
    methods: {
      validateUrlQuery() {
        const query = this.$route.query;
        if (!query.app_key) {
          this.$message.error(this.$t('bind.invalid_app_key'));
        } else if (!query.token) {
          this.$message.error(this.$t('bind.invalid_token'));
        }
      },
      initQuery() {
        const args = this.$route.query;
        if (args) {
          const callbackParams = { client_app_key: args.app_key, token: args.token };
          this.$http.post('/api/auth/bind/callback', callbackParams).then((res) => {
            if (res.body.ok) {
              this.updateConfirmParams(res.body.data);
              this.logo_url = res.body.data.logo_url;
            } else if (res.body.reason === 'invalid argument' && 'token' in res.body.data) {
              this.$message.error(this.$t('bind.invalid_token'));
            } else if (res.body.reason === 'invalid argument' && 'client_app_key' in res.body.data) {
              this.$message.error(this.$t('bind.invalid_app_key'));
            }
          });
        }
      },
      updateConfirmParams(data) {
        this.bindParams = data;
        this.current_bind = data.mode;
        this.confirmForm.email = data.email;
        this.confirmForm.app_name = data.app_name;
        this.confirmForm.app_user_id = data.app_user_id;
        if (this.current_bind === 'bind_user') {
          this.$message.error(this.$t('bind.bind_user'));
        }
      },
      confirmBind() {
        this.$refs.confirmForm.validate((valid) => {
          if (valid) {
            this.$http.post('/api/auth/bind/confirm', this.confirmForm).then((res) => {
              if (res.body.ok) {
                this.$message.success(this.$t('bind.success'));
                this.current_bind = 'bind_user';
              } else if (res.body.reason === 'invalid username') {
                this.$message.error(this.$t('bind.existed_username'));
              } else if (res.body.reason === 'invalid argument' && 'password' in res.body.data) {
                this.$message.error(this.$t('rules.password'));
              } else if (res.body.reason === 'not found') {
                this.$message.error(this.$t('bind.invalid_token'));
              }
            }).catch((res) => {
              if (res.body.reason === 'not found') {
                this.$message.error(this.$t('bind.invalid_token'));
              }
            });
          }
        });
      },
    },
    created() {
      this.validateUrlQuery();
      this.initQuery();
    },
  };
</script>



// WEBPACK FOOTER //
// BindUser.vue?8e768e38